import { isPlatform } from '@ionic/react';

export const tooltipTrigger = isPlatform('desktop') ? 'hover' : ' focus';
